/* ══════════════════════════════════════════════════════════════════════
   LA CELEBRACIÓN · confeti + aplausos · réplica de PROMPT_PESTANA_PAUTAS
   §8.1 (física, colores de dos caras, destello metalizado, dos cañones,
   palmas con su keyframe). Pieza COMPARTIDA por «Mis pautas» (marcar) y
   «Mi motivación» (subir de nivel). No es un adorno: no se omite.

   celebrar(fuerte):
     fuerte=false → un cañón, 170 trozos, manos 78px  (marcar uno / subir nivel)
     fuerte=true  → dos cañones, 300 cada uno, manos 104px (acabar pauta / meta)
   Con prefers-reduced-motion NO se crea nada (el texto del premio lo pone la UI).
   ══════════════════════════════════════════════════════════════════════ */

const COLORES_CONFETI = [
  { a: '#4DB6B0', b: '#8FD6D2' },
  { a: '#2E7F7B', b: '#5FA8A4' },
  { a: '#0F1F2E', b: '#3A5566' },
  { a: '#C4E8E5', b: '#EAF7F6' },
  { a: '#C97A2B', b: '#E3A567' },
];

const rnd = (a, b) => a + Math.random() * (b - a);

export function celebrar(fuerte) {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const dpr = window.devicePixelRatio || 1;
  const an = window.innerWidth, al = window.innerHeight;
  const canvas = document.createElement('canvas');
  canvas.className = 'fv-confeti';
  Object.assign(canvas.style, { position: 'fixed', inset: '0', zIndex: '60', pointerEvents: 'none' });
  canvas.width = an * dpr; canvas.height = al * dpr;
  canvas.style.width = an + 'px'; canvas.style.height = al + 'px';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  const trozos = [];
  const n = fuerte ? 300 : 170;
  const disparar = (ox, oy, dir, cuantos) => {
    for (let k = 0; k < cuantos; k++) {
      const ang = (-90 + dir * rnd(4, 44)) * Math.PI / 180;
      const vel = rnd(26, 46);
      const col = COLORES_CONFETI[(Math.random() * COLORES_CONFETI.length) | 0];
      const forma = Math.random() < 0.25 ? 'serp' : (Math.random() < 0.187 ? 'redonda' : 'papel');
      trozos.push({
        x: ox, y: oy,
        vx: Math.cos(ang) * vel, vy: Math.sin(ang) * vel,
        gir: rnd(0, Math.PI * 2), vgir: rnd(-0.2, 0.2),
        fase: rnd(0, Math.PI * 2), vfase: rnd(0.15, 0.32), vaiven: rnd(0.6, 2.2),
        w: forma === 'serp' ? rnd(4, 7) : rnd(9, 15),
        h: forma === 'serp' ? rnd(16, 26) : (forma === 'redonda' ? 0 : rnd(9, 15)),
        redonda: forma === 'redonda', r: rnd(5, 8),
        col, metal: Math.random() < 0.55,
        tope: rnd(1.15, 2.65), subiendo: true,
      });
    }
  };
  disparar(an * 0.10, al * 0.98, 1, n);
  if (fuerte) disparar(an * 0.90, al * 0.98, -1, n);

  const MAX = fuerte ? 7000 : 5800;
  const t0 = performance.now();
  const paso = (t) => {
    const vida = t - t0;
    ctx.clearRect(0, 0, an, al);
    const fade = vida > MAX - 1100 ? Math.max(0, (MAX - vida) / 1100) : 1;
    for (const p of trozos) {
      const G = p.subiendo ? 0.78 : 0.16;
      const ROCE = p.subiendo ? 0.975 : 0.965;
      p.vy += G;
      if (p.vy > 0) p.subiendo = false;
      if (!p.subiendo && p.vy > p.tope) p.vy = p.tope; // velocidad límite al caer → FLOTA
      p.vx *= ROCE;
      p.fase += p.vfase;
      p.x += p.vx + Math.sin(p.fase) * p.vaiven;
      p.y += p.vy;
      p.gir += p.vgir;
      if (p.y > al + 40) continue;

      const cf = Math.cos(p.fase);
      const cara = cf > 0 ? p.col.a : p.col.b;
      const luz = Math.pow(Math.abs(cf), p.metal ? 9 : 26) * (p.metal ? 0.96 : 0.45);
      ctx.save();
      ctx.globalAlpha = fade;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.gir + Math.sin(p.fase) * 0.35);
      ctx.scale(Math.max(0.06, Math.abs(cf)), 1); // se ve de canto y se estrecha → destello
      ctx.fillStyle = cara;
      if (p.redonda) { ctx.beginPath(); ctx.arc(0, 0, p.r, 0, Math.PI * 2); ctx.fill(); }
      else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      if (luz > 0.01) { ctx.globalAlpha = fade * luz; ctx.fillStyle = '#fff';
        if (p.redonda) { ctx.beginPath(); ctx.arc(0, 0, p.r, 0, Math.PI * 2); ctx.fill(); }
        else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); }
      ctx.restore();
    }
    if (vida < MAX) requestAnimationFrame(paso);
    else canvas.remove();
  };
  requestAnimationFrame(paso);

  // ── Los aplausos · a la vez que el confeti ──
  const palmas = document.createElement('div');
  palmas.className = 'fv-palmas' + (fuerte ? ' es-fuerte' : '');
  palmas.innerHTML =
    '<span class="fv-palma fv-palma--izq"><img src="/aplauso.svg" aria-hidden="true"></span>' +
    '<span class="fv-palma fv-palma--der"><img src="/aplauso.svg" aria-hidden="true"></span>';
  document.body.appendChild(palmas);
  setTimeout(() => palmas.remove(), fuerte ? 3400 : 2400);
}
